export class DraftConsumptionItem {
  constructor(
    public itemId: number,
    public quantity: number,
    public lot: string | undefined,
    public bestBefore: string | undefined,
    public expiry: string | undefined
  ) { }
}

export default class DraftConsumption {
  constructor(
    public patientCode: string,
    public nonBillable: boolean,
    public consumedItems: DraftConsumptionItem[],
    public pmsMandatorId?: string) { }
}
